"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.mapDispatchToProps = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactSpring = require("react-spring");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _account = _interopRequireDefault(require("./forms/account"));

var _adress = _interopRequireDefault(require("./forms/adress"));

var _agreements = _interopRequireDefault(require("./forms/agreements"));

var _alreadyRegistered = _interopRequireDefault(require("./forms/alreadyRegistered"));

var _confirm = _interopRequireDefault(require("./forms/confirm"));

var _error = _interopRequireDefault(require("./forms/error"));

var _portalInvitationError = _interopRequireDefault(require("./forms/portalInvitationError"));

var _language = _interopRequireDefault(require("./forms/language"));

var _vatCheck = _interopRequireDefault(require("./forms/vatCheck"));

var _excluded = ["vatAlreadyExists", "valid"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mapStateToProps = function mapStateToProps() {
  return {};
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getTranslations: function getTranslations(locale) {
      var langCode = locale.substring(0, Math.max(2, locale.lastIndexOf('-')));
      var url = "".concat(ENV.getTranslationsRestAPI);
      url = url.replace(/language=[^&]*/, "language=" + langCode);
      fetch(url, {
        method: 'GET'
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        dispatch((0, _nicbaseReducers.addTranslations)(langCode, response));
        dispatch((0, _nicbaseReducers.changeLocale)(locale));
      });
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;
var urlParams = new URLSearchParams(window.location.search);
var trans = urlParams.get('trans') || '';
var lang = urlParams.get('lang') || 'en-GB';
var initiatorName = urlParams.get('name') || '';

var PortalRegistration = function PortalRegistration(_ref) {
  var getTranslations = _ref.getTranslations;

  var _useState = (0, _react.useState)({
    defaultLanguage: lang,
    transactionCode: trans
  }),
      _useState2 = _slicedToArray(_useState, 2),
      infos = _useState2[0],
      setInfos = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      index = _useState4[0],
      set = _useState4[1];

  var firstUpdate = (0, _react.useRef)(true);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      transactionCodeError = _useState6[0],
      setTransactionCodeError = _useState6[1];

  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      getTranslations(infos.defaultLanguage);
    }
  }, [getTranslations, infos.defaultLanguage, infos.transactionCode]);
  var onClick = (0, _react.useCallback)(function () {
    return set(function (state) {
      return (state + 1) % 6;
    });
  }, []);

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isError = _useState8[0],
      setIsError = _useState8[1];

  var sendFormular = function sendFormular(data) {
    fetch(ENV.portalRegistrationRestAPI, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(function (response) {
      if (response.status !== 201) {
        setIsError(true);
      }
    })["catch"](function () {
      setIsError(true);
    });
  };

  var timeoutRef = (0, _react.useRef)();

  var handleClick = function handleClick() {
    fetch("".concat(ENV.transactionCodeValidationRestAPI, "?trans=").concat(infos.transactionCode), {
      method: 'GET'
    }).then(function (response) {
      if (response.ok) {
        response.json().then(function (result) {
          if (result !== "REQUESTED") {
            setTransactionCodeError(true);
            setInfos(_objectSpread(_objectSpread({}, infos), {}, {
              result: result
            }));
          }
        });
      }
    })["catch"](function () {
      // The API got failed for some reason. We ignore it in that case.
      timeoutRef.current = setTimeout(function () {}, 1400);
    });
  };

  var pages = (0, _react.useMemo)(function () {
    return [function (_ref2) {
      var style = _ref2.style;
      return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        className: "h-full w-full bg-cyan-500",
        style: _objectSpread({}, style)
      }, /*#__PURE__*/_react["default"].createElement(_language["default"], {
        infos: infos,
        onNextClick: function onNextClick(e) {
          setInfos(_objectSpread(_objectSpread({}, infos), {}, {
            defaultLanguage: e
          }));
          onClick();
          handleClick();
        },
        onLanguageChange: function onLanguageChange(e) {
          getTranslations(e);
        }
      }));
    }, function (_ref3) {
      var style = _ref3.style;
      return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        className: "h-full w-full bg-cyan-500",
        style: _objectSpread({}, style)
      }, transactionCodeError ? /*#__PURE__*/_react["default"].createElement(_portalInvitationError["default"], {
        data: {
          transactionCodeStatus: infos.result,
          transactionCode: infos.transactionCode
        }
      }) : /*#__PURE__*/_react["default"].createElement(_agreements["default"], {
        initiatorName: initiatorName,
        onNextClick: function onNextClick() {
          onClick();
        }
      }));
    }, function (_ref4) {
      var style = _ref4.style;
      return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        className: "h-full w-full bg-cyan-500",
        style: _objectSpread({}, style)
      }, /*#__PURE__*/_react["default"].createElement(_vatCheck["default"], {
        onNextClick: function onNextClick(e) {
          setInfos(_objectSpread(_objectSpread({}, infos), e));
          onClick();
        }
      }));
    }, function (_ref5) {
      var style = _ref5.style;
      return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        className: "h-full w-full bg-cyan-500",
        style: _objectSpread({}, style)
      }, infos.vatAlreadyExists ? /*#__PURE__*/_react["default"].createElement(_alreadyRegistered["default"], {
        data: {
          vatOwner: infos.vatOwner,
          vat: infos.vat,
          valid: infos.valid,
          vatAlreadyExists: infos.vatAlreadyExists,
          countryCode: infos.address.countryCode,
          contactMail: infos.contactMail
        }
      }) : /*#__PURE__*/_react["default"].createElement(_adress["default"], {
        infos: infos,
        onNextClick: function onNextClick(e) {
          setInfos(_objectSpread(_objectSpread({}, infos), e));
          onClick();
        }
      }));
    }, function (_ref6) {
      var style = _ref6.style;
      return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        className: "h-full w-full bg-cyan-500",
        style: _objectSpread({}, style)
      }, /*#__PURE__*/_react["default"].createElement(_account["default"], {
        infos: infos,
        onNextClick: function onNextClick(e) {
          setInfos(_objectSpread(_objectSpread({}, infos), e));
          onClick();

          var _infos$e = _objectSpread(_objectSpread({}, infos), e),
              vatAlreadyExists = _infos$e.vatAlreadyExists,
              valid = _infos$e.valid,
              other = _objectWithoutProperties(_infos$e, _excluded);

          sendFormular(other);
        }
      }));
    }, function (_ref7) {
      var style = _ref7.style;
      return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        className: "h-full w-full bg-cyan-500",
        style: _objectSpread({}, style)
      }, isError ? /*#__PURE__*/_react["default"].createElement(_error["default"], null) : /*#__PURE__*/_react["default"].createElement(_confirm["default"], null));
    }];
  }, [getTranslations, infos, isError, onClick]);
  var transitions = (0, _reactSpring.useTransition)(index, {
    from: {
      opacity: 0,
      transform: 'translate3d(100%,0,0)'
    },
    enter: {
      opacity: 1,
      transform: 'translate3d(0%,0,0)'
    },
    leave: {
      opacity: 0,
      transform: 'translate3d(-50%,0,0)'
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-full bg-cyan-500 overflow-x-hidden"
  }, transitions(function (style, item) {
    var Page = pages[item];
    return /*#__PURE__*/_react["default"].createElement(Page, {
      style: style
    });
  }));
};

PortalRegistration.propTypes = {
  getTranslations: _propTypes["default"].func
};

var noop = function noop() {};

PortalRegistration.defaultProps = {
  getTranslations: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PortalRegistration));

exports["default"] = _default;